import { useLocation, useNavigate } from 'react-router-dom'

import { paths } from 'src/config/paths'
import { Button } from 'src/shared/components/ui/buttons/button'
import { ResponsivePopup } from 'src/shared/components/ui/popups/responsive-popup'
import { useMyUserData } from 'src/shared/features/users/api/accounts/use-my-user'
import { UserCard } from 'src/shared/features/users/components/cards/user-card'
import { usePopupStore } from 'src/shared/store/popup-store'

export const CompleteProfilePopup = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { showCompleteProfile, setShowCompleteProfile } = usePopupStore()
  const { data: user } = useMyUserData()
  return (
    <ResponsivePopup
      trigger={<div />}
      open={showCompleteProfile}
      onOpenChange={setShowCompleteProfile}
      title="Verify your profile"
      dark
    >
      <div className="flex flex-col items-center space-y-10">
        <UserCard
          userId={user?.id}
          buttonType="none"
          className="w-4/5"
          showUsername={false}
          showAddress={false}
          showPoints={false}
        />
        <p className="text-center text-primary-foreground/90">
          No shortcuts - complete these fields to officially be a part of the network.
        </p>
        <Button
          variant="secondaryInverse"
          onClick={() => {
            navigate(paths.users.completeProfile.getHref(location.pathname))
            setShowCompleteProfile(false)
          }}
          className="w-full"
        >
          Continue
        </Button>
      </div>
    </ResponsivePopup>
  )
}
